export const loadState = (key: string): Record<string, string> | undefined => {
  try {
    const serializedState = localStorage.getItem(key);
    if (!serializedState) {
      return undefined;
    }
    return JSON.parse(serializedState) as Record<string, string>;
  } catch (err) {
    return undefined;
  }
};

export const saveState = <T>(state: T, key: string): void => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    // ignore write errors
  }
};

export const clearState = (key: string): void => {
  localStorage.removeItem(key);
};
